import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { CmxDropdownViewComponent } from "./components/cmx-dropdown-view.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    declarations: [
        CmxDropdownViewComponent,
    ],
    exports: [
        CmxDropdownViewComponent,
    ],
})
export class CmxDropdownViewModule { }
